import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { ReactNode } from "react";

interface FilterCardProps {
  label: string;
  typeIcon?: IconType;
  isDisabled?: boolean;
  children?: ReactNode;
  fullWidth?: boolean;
}

export function FilterCard({
  label,
  typeIcon: TypeIcon,
  isDisabled,
  children,
  fullWidth
}: FilterCardProps) {
  return (
    <Box gridColumn={fullWidth ? "span 2" : undefined}>
      <Box
        bg="rgba(230, 237, 244, 0.3)"
        border="1px solid"
        borderColor={"rgba(230, 237, 244, 0.5)"}
        borderRadius="10px"
        p="10px"
        transition="border-color 0.15s"
        opacity={isDisabled ? 0.6 : 1}
      >
        <Flex
          align="flex-start"
          justify="space-between"
          mb={children ? "8px" : "0"}
        >
          <Text
            fontSize="13px"
            fontWeight="600"
            color="#1E293B"
            lineHeight="1.4"
            wordBreak="break-word"
            flex={1}
            minW={0}
          >
            {label}
          </Text>

          {TypeIcon && (
            <Box color="#CBD5E1" flexShrink={0} ml="4px" mt="1px">
              <TypeIcon size={13} />
            </Box>
          )}
        </Flex>

        {children}
      </Box>
    </Box>
  );
}

interface FilterGridProps {
  children: ReactNode;
}

export function FilterGrid({ children }: FilterGridProps) {
  return <Stack spacing="8px">{children}</Stack>;
}
